module.exports={render:function (){with(this) {
  return _h('nav', {
    staticClass: "ion-navbar ion-toolbar toolbar ",
    class: ['toolbar-' + theme, aColor]
  }, [_h('div', {
    staticClass: "toolbar-background ",
    class: ['toolbar-background-' + theme]
  }), " ", _t("buttons"), " ", _h('div', {
    staticClass: "toolbar-content ",
    class: ['toolbar-content-' + theme]
  }, [_t("default")])])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e78f77c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/src/toolbar.vue
// module id = 157
// module chunks = 0